import { render, staticRenderFns } from "./StoragePackView.vue?vue&type=template&id=2c1e9b6a&scoped=true&"
import script from "./StoragePackView.vue?vue&type=script&lang=js&"
export * from "./StoragePackView.vue?vue&type=script&lang=js&"
import style0 from "./StoragePackView.vue?vue&type=style&index=0&id=2c1e9b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e9b6a",
  null
  
)

export default component.exports